import { lazy } from 'react'

export const LowBatteryVariant1 = lazy(() => import('./LowBatteryVariant1'))
